import { Link, Tooltip } from '@customerio/pluma-components/react';

type ClearSelectionLinkProps = {
  onClearSelection: () => void;
};

export function ClearSelectionLink({ onClearSelection }: ClearSelectionLinkProps) {
  return (
    <Link onClick={onClearSelection} variant="secondary" isUnderlined>
      Clear selection
    </Link>
  );
}

type SelectAllLinkProps = {
  onSelectAll: () => void;
  isDisabled: boolean;
  /** The total is unknown (-1): generic label, and a tooltip explaining why select-all is off. */
  unknownTotal: boolean;
  /** "Select {N} people" label body, e.g. "3 people". */
  peopleToSelectCount: string;
  /** The plural people noun (taxonomy term). */
  peoplePlural: string;
};

export function SelectAllLink({
  onSelectAll,
  isDisabled,
  unknownTotal,
  peopleToSelectCount,
  peoplePlural,
}: SelectAllLinkProps) {
  const tooltip = `The search returned too many matches to select all ${peoplePlural}. Try refining the search to narrow the results.`;
  return (
    <Tooltip placement="top" isDisabled={!unknownTotal} content={tooltip} isCustom>
      {(context) => (
        <Link
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
          isDisabled={isDisabled}
          onClick={onSelectAll}
          variant="secondary"
          isUnderlined
        >
          {unknownTotal ? `Select all ${peoplePlural}` : `Select ${peopleToSelectCount}`}
        </Link>
      )}
    </Tooltip>
  );
}
